import { createStyles, ITheme, makeStyles } from "@chainsafe/common-theme";
import React, { useState, useEffect, PropsWithChildren } from "react";
import { useChainbridge } from "../Contexts/ChainbridgeContext";
import { ChilizConfigProvider } from '../config/configProvider'
import { useCookieConsent } from "../lib/cookie-consent/useCookieConsent";

const useStyles = makeStyles(
  ({ constants, palette, zIndex, breakpoints }: ITheme) => {
    return createStyles({
      footer: {
        bottom: 0,
        background: "#FFFFFF",
        width: '100%',
        padding: '20px 3.5%',
        display: 'flex',
        gap: '5px'
      },
      managePreferences: {
        all: 'unset',
        cursor: 'pointer',
        textDecoration: 'underline'
      }
    });
  }
);

export const AppFooter = (): JSX.Element => {
  const classes = useStyles();
  const { homeConfig } = useChainbridge();
  const [networkId, setNetworkId] = useState(0)
  const { showPreferences, isConsentEnabled } = useCookieConsent()

  useEffect(() => {
    setNetworkId(homeConfig?.networkId || 0)
  }, [homeConfig?.networkId])

  const config = new ChilizConfigProvider()
  let chainDetails:any
  
  if(networkId === 0 || undefined) 
    chainDetails = config.getDefaultChainDetails()

  if(networkId && networkId !== 0)
    chainDetails = config.getConfig(networkId)

  const { privacyPolicyUrl, termsAndConditionsUrl } = chainDetails
  const privacyPolicyUrlEmpty = privacyPolicyUrl !== undefined && privacyPolicyUrl.length === 0
  const termsAndConditionsUrlEmpty = termsAndConditionsUrl !== undefined && termsAndConditionsUrl.length === 0
  if (privacyPolicyUrlEmpty && termsAndConditionsUrlEmpty) {
    return <></>
  }
  return (
    <footer className={classes.footer}>
      <Separate>
        {privacyPolicyUrl && <a href={privacyPolicyUrl} target='_blank' rel="noreferrer">Privacy Policy</a>}
        {termsAndConditionsUrl && <a href={termsAndConditionsUrl} target='_blank' rel="noreferrer">Terms & conditions</a>}
        {isConsentEnabled && <button onClick={showPreferences} className={classes.managePreferences}>Manage Preferences</button>}
      </Separate>
    </footer>
  )
}

function Separate({ children, separator = '-' }: PropsWithChildren<{ separator?: string }>): JSX.Element {
  const childrenArray = React.Children.toArray(children);
  const lastIdx = childrenArray.length - 1;

  return (
    <>
      {childrenArray.map((child, index) => (
        <React.Fragment key={index}>
          {child}
          {index < lastIdx && ` ${separator} `}
        </React.Fragment>
      ))}
    </>
  );
}
